import Reveal from '@/components/base/Reveal';
import SectionHeading from '@/components/base/SectionHeading';
import { accent } from '@/components/feature/solution/theme';

interface BasicItem {
  label: string;
  value: string;
}

interface Inspection {
  name: string;
  result: string;
  std: string;
}

interface TraceProfileProps {
  basicTitle: string;
  basic: BasicItem[];
  inspectionTitle: string;
  inspectionNote: string;
  inspections: Inspection[];
}

export default function TraceProfile({
  basicTitle,
  basic,
  inspectionTitle,
  inspectionNote,
  inspections,
}: TraceProfileProps) {
  const a = accent('green');

  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-[1200px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-8 items-start">
          {/* 产品基本信息 */}
          <Reveal>
            <div className="h-full rounded-2xl border border-background-200 bg-background-100 p-6 md:p-8">
              <div className="flex items-center gap-2.5">
                <span className={`w-9 h-9 flex items-center justify-center rounded-md ${a.iconBox}`}>
                  <i className="ri-file-list-3-line text-lg"></i>
                </span>
                <h2 className="font-heading font-bold text-foreground-950 text-base md:text-lg">{basicTitle}</h2>
              </div>

              <dl className="mt-6 divide-y divide-background-200">
                {basic.map((item) => (
                  <div key={item.label} className="flex flex-col sm:flex-row sm:items-baseline gap-1 sm:gap-4 py-3.5">
                    <dt className="w-full sm:w-[104px] shrink-0 text-sm text-foreground-500">{item.label}</dt>
                    <dd className="text-sm font-medium text-foreground-900">{item.value}</dd>
                  </div>
                ))}
              </dl>
            </div>
          </Reveal>

          {/* 质量检测结果 */}
          <Reveal delay={100}>
            <div className="h-full rounded-2xl border border-background-200 bg-background-100 p-6 md:p-8">
              <div className="flex items-center gap-2.5">
                <span className={`w-9 h-9 flex items-center justify-center rounded-md ${a.iconBox}`}>
                  <i className="ri-shield-check-line text-lg"></i>
                </span>
                <h2 className="font-heading font-bold text-foreground-950 text-base md:text-lg">{inspectionTitle}</h2>
              </div>

              <ul className="mt-6 space-y-3">
                {inspections.map((row) => (
                  <li
                    key={row.name}
                    className="flex items-center justify-between gap-4 rounded-xl bg-background-50 border border-background-200 px-4 py-3"
                  >
                    <div className="min-w-0">
                      <div className="text-sm text-foreground-900 truncate">{row.name}</div>
                      <div className="mt-0.5 text-xs text-foreground-500">{row.std}</div>
                    </div>
                    <span className={`shrink-0 inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-semibold whitespace-nowrap ${a.badgeLight}`}>
                      <i className="ri-check-line"></i>
                      {row.result}
                    </span>
                  </li>
                ))}
              </ul>

              <p className="mt-5 flex items-start gap-2 text-xs text-foreground-500 leading-relaxed">
                <i className={`${a.text} ri-information-line mt-0.5`}></i>
                <span>{inspectionNote}</span>
              </p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}